/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'order': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M6.322 2.683c2.29-2.06 5.6-2.57 8.43-1.31.22.11.37.32.41.56.03.24-.05.49-.23.65h0l-3.67 3.64 2.38 2.34 3.72-3.6a.75.75 0 01.67-.2c.25.04.46.2.56.42 1.29 2.77.77 6.03-1.33 8.28-2.1 2.25-5.36 3.05-8.29 2.03h0l-2.82 2.77a3.414 3.414 0 01-4.77-.02c-1.3-1.3-1.29-3.39.03-4.68h0l2.82-2.77c-1.02-2.87-.2-6.06 2.09-8.11zm.47 1.664a6.016 6.016 0 00-.97 6.35c.13.28.06.61-.16.83l-3.17 3.11c-.71.7-.71 1.83 0 2.53.72.67 1.86.67 2.58 0l3.17-3.11c.22-.22.56-.28.85-.16 2.16.91 4.67.55 6.47-.95 1.8-1.5 2.58-3.86 2.01-6.11l-3.39 3.32a.8.8 0 01-1.08 0l-3.46-3.4c-.3-.29-.3-.77 0-1.06l3.38-3.32c-2.29-.56-4.7.21-6.23 1.97z" _fill="#FFF" _stroke="#2B2D39" stroke-width=".2" fill-rule="evenodd" stroke-dasharray="0,0"/>'
  }
})
